import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { Formik, Form } from "formik";

import LdsTextField from "../LdsTextField";
import LdsValidationError from "../LdsValidationError";
import LdsButton from "../LdsButton";
import { BootstrapAlert } from "../BootstrapAlert";
import { PasswordProtectedLoginSchema } from "../../validationSchema/PasswordProtectedLoginSchema";

import amyvidIcon from "../../assets/icon_amyid.png";

export const PasswordProtectedModal = () => {
  const [isVisible, setVisible] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = ({ username, password }) => {
    console.log("process.env :>> ", process.env);
    if (
      username === process?.env?.REACT_APP_PWD_PROTECTED_USER &&
      btoa(password) === process?.env?.REACT_APP_PWD_PROTECTED_USER_PASSWORD
    ) {
      setVisible(false);
      sessionStorage.setItem("isAutherizedPasswordProtected", 1);
    } else {
      setErrorMessage("Access Denied! Please enter valid credential.");
    }
  };
  return (
    <>
      {" "}
      <Modal
        show={isVisible}
        fullscreen={true}
        backdrop="static"
        keyboard={false}
        enforceFocus={true}
      >
        <Modal.Body>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-sm-12 col-md-6">
                <h1 className="blue text-uppercase b text-center">
                  Please log in
                  <img
                    src={amyvidIcon}
                    alt="Amyvid Logo"
                    style={{ width: "50px", padding: "1rem 0" }}
                  />{" "}
                </h1>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-sm-12 col-md-4">
                <BootstrapAlert variant="danger" message={errorMessage} />{" "}
                <Formik
                  initialValues={{
                    username: "",
                    password: "",
                  }}
                  validationSchema={PasswordProtectedLoginSchema}
                  onSubmit={handleSubmit}
                >
                  {({ handleChange, values, errors, touched }) => (
                    <Form>
                      <div className="row">
                        <div className="col">
                          <LdsTextField
                            onChange={handleChange}
                            label="User Name"
                            labelRequired
                            name="username"
                            id="username"
                            type="text"
                            error={errors.username && touched.username}
                          />
                          {errors.username && touched.username && (
                            <LdsValidationError id="errusername">
                              {errors.username}
                            </LdsValidationError>
                          )}
                          &nbsp;
                          <br />
                          <LdsTextField
                            onChange={handleChange}
                            label="Password"
                            labelRequired
                            name="password"
                            id="password"
                            type="password"
                            error={errors.password && touched.password}
                          />
                          {errors.password && touched.password && (
                            <LdsValidationError id="errpassword">
                              {errors.password}
                            </LdsValidationError>
                          )}
                          <div className="col-sm-4 col-md-12">
                            <LdsButton type="submit" classes="blue-button mt-3">
                              Sign In
                            </LdsButton>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
